import { getAuthMethod } from "../../../../modules/helper";

const searchCity = async (key, loading, set) => {
  set([]);
  loading(true);

  const response = await getAuthMethod("/address/v1/search-city", {
    srcinput: key,
  });

  if (response) {
    set(response.data.cities);
  }

  loading(false);
};

export default searchCity;
